class Pagination {
    onPageChanged: (fromPage: number, toPage: number) => void

    paginationView: JQuery
    currentPage: number = 0
    totalPages: number = 1
    itemsPerPage: number
    private urlParam: string
    private historyBehavior: 'push' | 'replace'

    constructor(paginationView: JQuery) {
        this.paginationView = paginationView
        this.itemsPerPage = paginationView.data('items-per-page')

        this.urlParam = paginationView.data('url-param')

        if (this.urlParam) {
            this.historyBehavior = paginationView.data('history-behavior')
            const params = new URLSearchParams(window.location.search)
            const page = parseInt(params.get(this.urlParam))
            if (page > 0) {
                this.currentPage = page - 1
            }
            window.onpopstate = (e) => {
                if (e.state?.page) {
                    const page = this.currentPage
                    this.currentPage = e.state.page - 1
                    this.onPageChanged(page, this.currentPage)
                }
            }
        }

        paginationView.find('.first-page').click(() => {
            const page = this.currentPage
            this.currentPage = 0
            this.onPageChanged(page, this.currentPage)
        })
        paginationView.find('.last-page').click(() => {
            const page = this.currentPage
            this.currentPage = this.totalPages - 1
            this.onPageChanged(page, this.currentPage)
        })
        paginationView.find('.next-page').click(() => {
            const page = this.currentPage
            this.currentPage = Math.min(page + 1, this.totalPages - 1)
            this.onPageChanged(page, this.currentPage)
        })
        paginationView.find('.previous-page').click(() => {
            const page = this.currentPage
            this.currentPage = Math.max(page - 1, 0)
            this.onPageChanged(page, this.currentPage)
        })
    }

    update(totalPages: number) {
        const pagination = this.paginationView
        const current = pagination.find('.current-page')
        const bullets = pagination.find('.bullets')

        const page = this.currentPage
        this.totalPages = totalPages

        if (totalPages === 0) {
            pagination.addClass('disabled')
        } else {
            pagination.removeClass('disabled')
        }

        current.text(page + 1)

        if (bullets.length > 0) {
            bullets.empty()
            for (let i = 0; i < totalPages; i++) {
                const span = jQuery('<span/>')
                span.on('click', () => {
                    this.currentPage = i
                    this.onPageChanged(page, i)
                })
                if (i === page) {
                    span.addClass('current')
                }
                span.appendTo(bullets)
            }
        }

        const first = pagination.find('.first-page')
        const prev = pagination.find('.previous-page')
        const next = pagination.find('.next-page')
        const last = pagination.find('.last-page')

        if (first.length) {
            const firstText = first.data('text').replace('%p', '1')
            first.text(firstText)
        }

        if (last.length) {
            const lastText = last.data('text').replace('%p', totalPages)
            last.text(lastText)
        }

        if (prev.length) {
            const prevText = prev.data('text').replace('%p', Math.max(page, 1))
            prev.text(prevText)
        }

        if (next.length) {
            const nextText = next
                .data('text')
                .replace('%p', Math.min(page + 2, totalPages))
            next.text(nextText)
        }

        if (page === 0) {
            first.addClass('disabled')
            prev.addClass('disabled')
        } else {
            first.removeClass('disabled')
            prev.removeClass('disabled')
        }

        if (page === 1) {
            first.addClass('is-previous')
        } else {
            first.removeClass('is-previous')
        }

        if (page === totalPages - 1) {
            next.addClass('disabled')
            last.addClass('disabled')
        } else {
            next.removeClass('disabled')
            last.removeClass('disabled')
        }

        if (page === totalPages - 2) {
            last.addClass('is-next')
        } else {
            last.removeClass('is-next')
        }

        if (this.urlParam) {
            const qmIndex = window.location.href.indexOf('?')
            let params = new URLSearchParams()
            let urlBase = window.location.href + '?'
            if (qmIndex !== -1) {
                params = new URLSearchParams(
                    window.location.href.substr(qmIndex + 1),
                )
                urlBase = window.location.href.substring(0, qmIndex + 1)
            }
            const newPage = (this.currentPage + 1).toString()
            if (params.get(this.urlParam) !== newPage) {
                params.set(this.urlParam, newPage)
                if (this.historyBehavior === 'push') {
                    window.history.pushState(
                        { page: newPage },
                        null,
                        urlBase + params.toString(),
                    )
                } else {
                    window.history.replaceState(
                        { page: newPage },
                        null,
                        urlBase + params.toString(),
                    )
                }
            }
        }
    }
}

export default Pagination
